import { ResourceProvider } from "../../providers/resource.provider"
import { QueryOptions } from "../../helpers/query.options"
import { ajax } from "rxjs/ajax"
import { catchError, map } from "rxjs/operators"
import { of } from "rxjs"

import { GlobalAttribute } from "./GlobalAttribute"
import { GlobalAttributeSerializer } from "./serializer"

const GLOBAL_ATTRIBUTES_BASE_URL = "https://api.voulez-vous.ge"

export class GlobalAttributeProvider extends ResourceProvider<GlobalAttribute> {
    constructor() {
        super("rest_global_attributes", new GlobalAttributeSerializer())
    }

    async list(queryOptions?: QueryOptions, accessToken?: string) {
        const query = queryOptions?.toQueryString() || ""
        const url = `${GLOBAL_ATTRIBUTES_BASE_URL}/${this.endpoint}?${query}`
        const headers: Record<string, string> = { Accept: "*/*", "Content-Type": "application/json" }
        if (accessToken) headers.Authorization = `Bearer ${accessToken}`

        return ajax({ url, method: "GET", headers }).pipe(
            map((data: any) => {
                const results = Array.isArray(data.response?.data) ? data.response.data : []
                return {
                    results: results.map((item) => this.serializer.fromJson(item))
                }
            }),
            catchError((error) => of(error))
        ).toPromise()
    }
}

export const globalAttributeService = new GlobalAttributeProvider()
